import PropTypes from 'prop-types';
import classnames from 'classnames';
import { AccountCircle, DeleteOutlined } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';

import { ListItemWrapper } from 'components/ui';

import * as Styled from './ListItem.styles';
import { useMemo } from 'react';

export const ListItem = ({ item, onDelete }) => {
  const role = useMemo(() => {
    const isAdmin = item.roles.includes('ADMINISTRATOR');

    return {
      name: isAdmin ? 'admin' : 'user',
      label: isAdmin ? 'Administrator' : 'Użytkownik',
    };
  }, [item]);

  return (
    <ListItemWrapper>
      <Styled.Info>
        <AccountCircle className="icon" />
        <div className="info">
          <div className="name">{item.username}</div>
          <div className="email">{item.email}</div>
        </div>
      </Styled.Info>
      <Styled.Actions>
        <Styled.Role className={classnames({ green: role.name === 'admin' })}>{role.label}</Styled.Role>

        <IconButton color="error" onClick={onDelete} disabled={role.name === 'admin'}>
          <DeleteOutlined />
        </IconButton>
      </Styled.Actions>
    </ListItemWrapper>
  );
};

ListItem.propTypes = {
  item: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
};
